"use client"

import { useListData } from "react-stately"

import { MultiSelect, type SelectItemType } from "@/components/ui/select"

interface TagMultiSelectProps {
  label?: string
  placeholder?: string
  items: SelectItemType[]
  initialSelectedItems?: SelectItemType[]
  onItemInserted?: (id: string) => void
  onItemCleared?: (id: string) => void
  hint?: string
}

/**
 * TagMultiSelect component.
 * @param label - The label of the multi-select.
 * @param placeholder - The placeholder of the multi-select.
 * @param items - The items of the multi-select.
 * @param initialSelectedItems - The initial selected items of the multi-select.
 * @param onItemInserted - The callback function when an item is inserted.
 * @param onItemCleared - The callback function when an item is cleared.
 * @param hint - The hint of the multi-select.
 * @returns The TagMultiSelect component.
 */
export function TagMultiSelect({
  label = "Tags",
  placeholder = "Search and select tags",
  items,
  initialSelectedItems,
  onItemInserted,
  onItemCleared,
  hint,
}: TagMultiSelectProps) {
  const selectedItems = useListData<SelectItemType>({
    initialItems: initialSelectedItems ?? [],
  })

  return (
    <MultiSelect
      size="md"
      label={label}
      placeholder={placeholder}
      items={items}
      selectedItems={selectedItems}
      onItemInserted={(key) => onItemInserted?.(String(key))}
      onItemCleared={(key) => onItemCleared?.(String(key))}
      hint={hint}
    >
      {(item) => <MultiSelect.Item id={item.id} label={item.label} />}
    </MultiSelect>
  )
}
